import React, { Component } from 'react';
import './index.styl';

const clzpre = 'dsh-bimmodel';
// const min = 0;
// const max = 200;
// const init = 10000;
// const TIME = 100;

class BIMmodel extends Component {
    timer;
    constructor(props) {
        super(props);
        // this.state = {
        //     current: min
        // }
    }

    componentDidMount() {
        // this.timer = setTimeout(this.cycle, TIME);
    }

    componentWillUnmount() {
        // clearTimeout(this.timer);
    }

    // cycle = () => {
    //     this.setState(prev => {
    //         let current = prev.current + 1;
    //         if (current > max) {
    //             current = min;
    //         }
    //         return { current };
    //     }, () => {
    //         this.timer = setTimeout(this.cycle, TIME);
    //     });
    // }

    // getPngSeries = () => {
    //     const name = init + this.state.current;
    //     const url = require(`../../../common/images/BIMPNG/${name}.png`);
    //     return <img src={url} alt={name} />;
    // }

    render() {
        const url = require('../../../common/images/bim.gif');
        return <div className={`${clzpre} dsh-box`}>
            <h3>BIM模型展示</h3>
            <section>
                {/* {this.getPngSeries()} */}
                <img src={url} />
            </section>
        </div>;
    }
}

export default BIMmodel;